import React from 'react'
import { Link } from 'react-router-dom'

const FOOTER_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/assets/images/logo/techdigitwhite.png`

function FooterSix() {
    const currentYear = new Date().getFullYear()
    return (
        <footer className="td-footer-premium">
            <div className="td-footer-premium__inner">
                <div className="container">
                    <div className="row g-5 g-xl-5">
                        <div className="col-lg-3 col-md-6 col-12">
                            <div className="td-footer-premium__brand">
                                <Link to="/" className="td-footer-premium__logo">
                                    <img src={FOOTER_LOGO_SRC} alt="TechDigit Solutions" />
                                </Link>
                                <p className="td-footer-premium__disc">
                                    Dedicated teams, realistic timelines, and compliance built in from day one.
                                    We measure every engagement on outcomes—not promises.
                                </p>
                                <ul className="td-footer-premium__social">
                                    <li>
                                        <a
                                            href="https://www.linkedin.com/company/techdigitsolutions/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="TechDigit Solutions on LinkedIn"
                                        >
                                            <i className="fab fa-linkedin-in" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                            <div className="td-footer-premium__col">
                                <h5 className="td-footer-premium__title">Services We Offer</h5>
                                <ul className="td-footer-premium__links">
                                    <li><Link to="#">Medical Billing &amp; RCM</Link></li>
                                    <li><Link to="/cybersecurity">Cybersecurity</Link></li>
                                    <li><Link to="#">Call Center &amp; Support</Link></li>
                                    <li><Link to="#">Ebook &amp; Whitepaper Writing</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                            <div className="td-footer-premium__col">
                                <h5 className="td-footer-premium__title">Useful Links</h5>
                                <ul className="td-footer-premium__links">
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/about-us">About Us</Link></li>
                                    <li><Link to="/industries">Industries</Link></li>
                                    <li><Link to="/contactus">Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                            <div className="td-footer-premium__col">
                                <h5 className="td-footer-premium__title">Contact Us</h5>
                                <ul className="td-footer-premium__contact">
                                    <li>
                                        <span className="td-footer-premium__contact-icon" aria-hidden="true">
                                            <i className="fas fa-phone-alt" />
                                        </span>
                                        <a href="tel:+18252516570">+1 (825) 251-6570</a>
                                    </li>
                                    <li>
                                        <span className="td-footer-premium__contact-icon" aria-hidden="true">
                                            <i className="far fa-envelope" />
                                        </span>
                                        <a href="mailto:info@techdigitsolutions.com">info@techdigitsolutions.com</a>
                                    </li>
                                    <li>
                                        <span className="td-footer-premium__contact-icon" aria-hidden="true">
                                            <i className="fas fa-globe" />
                                        </span>
                                        <a href="https://www.techdigitsolutions.com" target="_blank" rel="noopener noreferrer">
                                            www.techdigitsolutions.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="td-footer-premium__bottom">
                <div className="container">
                    <div className="td-footer-premium__bottom-row">
                        <p className="td-footer-premium__copyright">
                            Copyright © {currentYear} TechDigit Solutions.
                            <span className="td-footer-premium__powered">
                                {' '}
                                Powered by{' '}
                                <a
                                    href="https://dxroots.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    DXRoots
                                </a>
                            </span>
                        </p>
                        <div className="td-footer-premium__legal">
                            <Link to="/privacy-policy">Privacy Policy</Link>
                            <span aria-hidden="true">|</span>
                            <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default FooterSix
